
export default function Certifications() {
  return (
    <section id="certifications" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
            Certificaciones y Cumplimiento
          </h2>
          <p className="text-lg text-slate-600 max-w-3xl mx-auto">
            Nuestros productos cumplen con los más altos estándares europeos de calidad, seguridad y medio ambiente
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="bg-slate-50 rounded-xl p-8 text-center hover:shadow-xl transition-all">
            <div className="w-24 h-24 bg-white rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg">
              <i className="ri-checkbox-circle-line text-5xl text-blue-900"></i>
            </div>
            <h3 className="text-xl font-bold text-slate-900 mb-3">
              Certificación CE
            </h3>
            <p className="text-sm text-slate-600 leading-relaxed">
              Todos nuestros productos cuentan con certificación CE, garantizando el cumplimiento de las normativas europeas de seguridad y calidad
            </p>
          </div>

          <div className="bg-slate-50 rounded-xl p-8 text-center hover:shadow-xl transition-all">
            <div className="w-24 h-24 bg-white rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg">
              <i className="ri-medal-line text-5xl text-blue-900"></i>
            </div>
            <h3 className="text-xl font-bold text-slate-900 mb-3">
              Sistemas ISO
            </h3>
            <p className="text-sm text-slate-600 leading-relaxed">
              Operamos bajo estrictos sistemas ISO de gestión de calidad y medio ambiente, asegurando procesos controlados y sostenibles
            </p>
          </div>

          <div className="bg-slate-50 rounded-xl p-8 text-center hover:shadow-xl transition-all">
            <div className="w-24 h-24 bg-white rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg">
              <i className="ri-shield-check-line text-5xl text-blue-900"></i>
            </div>
            <h3 className="text-xl font-bold text-slate-900 mb-3">
              Cumplimiento Normativo Europeo
            </h3>
            <p className="text-sm text-slate-600 leading-relaxed">
              Cumplimiento total con directivas europeas de compatibilidad electromagnética, baja tensión y eficiencia energética
            </p>
          </div>

          <div className="bg-slate-50 rounded-xl p-8 text-center hover:shadow-xl transition-all">
            <div className="w-24 h-24 bg-white rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg">
              <i className="ri-settings-3-line text-5xl text-blue-900"></i>
            </div>
            <h3 className="text-xl font-bold text-slate-900 mb-3">
              Fabricación Controlada
            </h3>
            <p className="text-sm text-slate-600 leading-relaxed">
              Producción propia con control total del proceso de fabricación, desde el diseño hasta la entrega final del producto
            </p>
          </div>
        </div>

        {/* CTA Final */}
        <div className="mt-24 bg-gradient-to-r from-blue-900 to-slate-900 rounded-2xl p-12 text-center">
          <h3 className="text-3xl md:text-4xl font-bold text-white mb-4">
            La continuidad de su operación comienza aquí
          </h3>
          <p className="text-xl text-blue-100 mb-8 max-w-2xl mx-auto">
            Solicite una evaluación técnica personalizada para su proyecto de infraestructura crítica
          </p>
          <button 
            onClick={() => {
              const element = document.getElementById('contact');
              if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
              }
            }}
            className="bg-white text-blue-900 px-10 py-4 rounded-lg text-base font-bold hover:bg-blue-50 transition-all shadow-xl hover:shadow-2xl whitespace-nowrap"
          >
            Solicitar Evaluación Técnica
          </button>
        </div>
      </div>
    </section>
  );
}
